import { FIELDS_TYPES } from "./type.config";
import { Moment } from "moment";

export const emailQueueListName = "EmailQueue";

export const techSupportEmail = "Evgeniy.Gudkov@abinbevefes.com;Dmitriy.Gorbachev@abinbevefes.com";
export const callbackSupportEmail = "Evgeniy.Gudkov@abinbevefes.com;Dmitriy.Gorbachev@abinbevefes.com";

export const emailListFields = {
  [emailQueueListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Subject: FIELDS_TYPES.STRING,
    Body: FIELDS_TYPES.STRING,
    Recepients: FIELDS_TYPES.STRING,
    CC: FIELDS_TYPES.STRING,
    BCC: FIELDS_TYPES.STRING,
    IsSent: FIELDS_TYPES.BOOLEAN,
    DateToBeSentAt: FIELDS_TYPES.DATE,
    IsProcessing: FIELDS_TYPES.BOOLEAN,
    NotificationID: FIELDS_TYPES.NUMBER,
    CheckDoc: FIELDS_TYPES.STRING,
    RepeatAt: FIELDS_TYPES.NUMBER,
    RepeatTimes: FIELDS_TYPES.NUMBER,
    RepeatTimesValue: FIELDS_TYPES.NUMBER,
    GosId: FIELDS_TYPES.STRING,
    AttachmentPaths: FIELDS_TYPES.JSON,
  },
};

export type EmailListFieldsRecordType = {
  [emailQueueListName]: {
    Title: string;
    ID: number;
    Subject: string;
    Body: string;
    Recepients: string;
    CC: string;
    BCC: string;
    IsSent: boolean;
    DateToBeSentAt: Date;
    IsProcessing: boolean;
    NotificationID: number;
    CheckDoc: string;
    RepeatAt: number;
    RepeatTimes: number;
    RepeatTimesValue: number;
    GosId: string;
    AttachmentPaths: string[];
  };
};

export type EmailListFieldsType = {
  [emailQueueListName]: {
    Title: string;
    ID: number;
    Subject: string;
    Body: string;
    Recepients: string;
    CC: string;
    BCC: string;
    IsSent: boolean;
    DateToBeSentAt: Moment;
    IsProcessing: boolean;
    NotificationID: number;
    CheckDoc: string;
    RepeatAt: number;
    RepeatTimes: number;
    RepeatTimesValue: number;
    GosId: string;
    AttachmentPaths: string[];
  };
};
